import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class HRParty  {
    _originalTypeClassName = "zERP.BO.HRParty";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
HRParty.translate = translateService;
}
this.Members = [];
this.RecommendationDecisionFiles = [];
this.PauseTerminationReasonFiles = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.IsStanding = false;
this.StartDate = null;
this.EndDate = null;
this.IsPaying = false;
this.PayAmount = null;
this.Description = null;
this.Status = null;
this.PayingPolicy = null;
this.NumberOfMembers = null;
this.RecommendationDecisionText = null;
this.PauseTerminationReasonText = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
IsStanding:any;
StartDate:any;
EndDate:any;
IsPaying:any;
PayAmount:any;
Description:any;
Status:any;
PayingPolicy:any;
NumberOfMembers:any;
RecommendationDecisionText:any;
PauseTerminationReasonText:any;
Members:any;
RecommendationDecisionFiles:any;
PauseTerminationReasonFiles:any;
Type:any;
Meeting:any;
static setMembers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Members == null) $this.Members = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Members.length > 0) {
                    Domain.HRParty.removeMembers($this, $this.Members[0]);
                }

                Domain.HRParty.addManyMembers($this, copyItems);
            }
static addManyMembers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.HRParty.addMembers($this, items[i]);
                }
            }
static addMembers = ($this, item) => {
                if ($this.Members == null) $this.Members = [];
                if (item == null || $this.Members.indexOf(item) > -1) return;
                $this.Members.push(item);
if (item.Party != $this) {
Domain.HRPartyMember.setParty(item, $this);
}
}
static addRangeMembers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.HRParty.addMembers($this, item));
            }
static removeMembers = ($this, item) => {
                if ($this == null || $this.Members == null || $this.Members.indexOf(item) === -1) return;
                var _index = $this.Members.indexOf(item);
                $this.Members.splice(_index, 1);
item.Party = null;
}
static clearMembers = ($this) => { $this.Members = null; }
static setRecommendationDecisionFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.RecommendationDecisionFiles == null) $this.RecommendationDecisionFiles = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RecommendationDecisionFiles.length > 0) {
                    Domain.HRParty.removeRecommendationDecisionFiles($this, $this.RecommendationDecisionFiles[0]);
                }

                Domain.HRParty.addManyRecommendationDecisionFiles($this, copyItems);
            }
static addManyRecommendationDecisionFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.HRParty.addRecommendationDecisionFiles($this, items[i]);
                }
            }
static addRecommendationDecisionFiles = ($this, item) => {
                if ($this.RecommendationDecisionFiles == null) $this.RecommendationDecisionFiles = [];
                if (item == null || $this.RecommendationDecisionFiles.indexOf(item) > -1) return;
                $this.RecommendationDecisionFiles.push(item);
}
static addRangeRecommendationDecisionFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.HRParty.addRecommendationDecisionFiles($this, item));
            }
static removeRecommendationDecisionFiles = ($this, item) => {
                if ($this == null || $this.RecommendationDecisionFiles == null || $this.RecommendationDecisionFiles.indexOf(item) === -1) return;
                var _index = $this.RecommendationDecisionFiles.indexOf(item);
                $this.RecommendationDecisionFiles.splice(_index, 1);
}
static clearRecommendationDecisionFiles = ($this) => { $this.RecommendationDecisionFiles = null; }
static setPauseTerminationReasonFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.PauseTerminationReasonFiles == null) $this.PauseTerminationReasonFiles = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PauseTerminationReasonFiles.length > 0) {
                    Domain.HRParty.removePauseTerminationReasonFiles($this, $this.PauseTerminationReasonFiles[0]);
                }

                Domain.HRParty.addManyPauseTerminationReasonFiles($this, copyItems);
            }
static addManyPauseTerminationReasonFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.HRParty.addPauseTerminationReasonFiles($this, items[i]);
                }
            }
static addPauseTerminationReasonFiles = ($this, item) => {
                if ($this.PauseTerminationReasonFiles == null) $this.PauseTerminationReasonFiles = [];
                if (item == null || $this.PauseTerminationReasonFiles.indexOf(item) > -1) return;
                $this.PauseTerminationReasonFiles.push(item);
}
static addRangePauseTerminationReasonFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.HRParty.addPauseTerminationReasonFiles($this, item));
            }
static removePauseTerminationReasonFiles = ($this, item) => {
                if ($this == null || $this.PauseTerminationReasonFiles == null || $this.PauseTerminationReasonFiles.indexOf(item) === -1) return;
                var _index = $this.PauseTerminationReasonFiles.indexOf(item);
                $this.PauseTerminationReasonFiles.splice(_index, 1);
}
static clearPauseTerminationReasonFiles = ($this) => { $this.PauseTerminationReasonFiles = null; }
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setMeeting = ($this, value) => {
var oldValue = $this.Meeting;
$this.Meeting = value;
if (value != null) {
if (oldValue != null && oldValue.HRParty != null) { oldValue.HRParty = null; }
if ($this.Meeting.HRParty !== $this) {
Domain.PartyMeeting.setHRParty(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}